export default __webpack_public_path__ + "static/media/EV Jump Start Lane Factsheet.28de1ed1.pdf";